import { SingleInputConnectIntegrationFormModal } from '@modules/common/components/SingleInputConnectIntegrationFormModal';
import { IntegrationChannelType, IntegrationType } from 'generated/graphql';
import { useState } from 'react';

interface EmailFormModalProps {
  integrationType: IntegrationType;
}

export const EmailFormModal = ({ integrationType }: EmailFormModalProps) => {
  const [displayName, setDisplayName] = useState('');

  return (
    <SingleInputConnectIntegrationFormModal
      inputFieldData={displayName}
      setInputFieldData={setDisplayName}
      channelType={IntegrationChannelType.Email}
      integrationType={integrationType}
      integrationData={{
        emailInbound: {
          displayName: displayName,
        },
      }}
      textFieldProps={{
        label: 'Display Name',
        placeholder: 'Enter Display Name',
      }}
      modalTitle="Email Inbound"
      buttonText="Add Email Inbound"
    />
  );
};
